export const isFaqItemActive = item => item?.is_active !== false

export const normalizeFaqActiveFlag = value => value !== false

/** Ensure section/question is_active flags are explicit before save. */
export const normalizeFaqSectionsForSave = sections => {
  if (!Array.isArray(sections)) {
    return []
  }
  return sections.map(section => ({
    ...section,
    title: section?.title || '',
    anchor: section?.anchor || '',
    is_active: normalizeFaqActiveFlag(section?.is_active),
    questions: (section?.questions || []).map(question => ({
      ...question,
      question: question?.question || '',
      answer: question?.answer || '',
      is_active: normalizeFaqActiveFlag(question?.is_active)
    }))
  }))
}

/** Omit inactive FAQ sections and questions for public rendering. */
export const filterFaqSectionsForDisplay = sections => {
  if (!Array.isArray(sections)) {
    return []
  }
  return sections
    .filter(isFaqItemActive)
    .map(section => ({
      ...section,
      questions: (section?.questions || []).filter(isFaqItemActive)
    }))
}
